var _defs, _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryRetailAndEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 800",
    width: 1200,
    height: 800,
    role: "img",
    "aria-label": "Abstract illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gretailandeco",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2F6560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163936"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "wretailandeco",
    cx: 0.2,
    cy: 0.1,
    r: 0.9
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#83ADA9",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83ADA9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "oretailandeco",
    cx: 0.85,
    cy: 0.85,
    r: 0.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4804",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4804",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#F5F8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#wretailandeco)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "url(#oretailandeco)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 150 478.88453079387546 C 400 408.88453079387546 560 548.8845307938755 800 436.88453079387546 S 1080 408.88453079387546 1120 394.88453079387546",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.5,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 524.8845307938755 C 400 442.88453079387546 560 606.8845307938755 800 475.68453079387547 S 1080 442.88453079387546 1120 426.4845307938755",
    fill: "none",
    stroke: "#FF4804",
    strokeOpacity: 0.85,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 570.8845307938755 C 400 476.88453079387546 560 664.8845307938755 800 514.4845307938755 S 1080 476.88453079387546 1120 458.08453079387544",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.36,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 616.8845307938755 C 400 510.88453079387546 560 722.8845307938755 800 553.2845307938754 S 1080 510.88453079387546 1120 489.68453079387547",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.29,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 150 662.8845307938755 C 400 544.8845307938755 560 780.8845307938755 800 592.0845307938755 S 1080 544.8845307938755 1120 521.2845307938754",
    fill: "none",
    stroke: "#548A85",
    strokeOpacity: 0.22,
    strokeWidth: 2.4,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 570,
    width: 34,
    height: 70,
    rx: 17,
    fill: "url(#gretailandeco)",
    fillOpacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 522,
    width: 34,
    height: 118,
    rx: 17,
    fill: "url(#gretailandeco)",
    fillOpacity: 0.48
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 474,
    width: 34,
    height: 166,
    rx: 17,
    fill: "url(#gretailandeco)",
    fillOpacity: 0.61
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 770,
    y: 426,
    width: 34,
    height: 214,
    rx: 17,
    fill: "url(#gretailandeco)",
    fillOpacity: 0.74
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 940,
    y: 378,
    width: 34,
    height: 262,
    rx: 17,
    fill: "url(#gretailandeco)",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryRetailAndEcommerce);
export default __webpack_public_path__ + "static/media/industry-retail-and-ecommerce.d47843913b713d18edeb483958c59ff5.svg";
export { ForwardRef as ReactComponent };